'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CountrySelectNative = (_temp2 = _class = function (_Component) {
	_inherits(CountrySelectNative, _Component);

	function CountrySelectNative() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, CountrySelectNative);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountrySelectNative.__proto__ || Object.getPrototypeOf(CountrySelectNative)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
			var onChange = _this.props.onChange;

			var value = event.target.value;
			onChange(value === 'ZZ' ? undefined : value);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(CountrySelectNative, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    name = _props.name,
			    value = _props.value,
			    options = _props.options,
			    disabled = _props.disabled,
			    tabIndex = _props.tabIndex,
			    className = _props.className,
			    SelectArrow = _props.selectArrowComponent;


			var selectedOption = void 0;
			for (var _iterator = options, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
				var _ref2;

				if (_isArray) {
					if (_i >= _iterator.length) break;
					_ref2 = _iterator[_i++];
				} else {
					_i = _iterator.next();
					if (_i.done) break;
					_ref2 = _i.value;
				}

				var option = _ref2;

				if (!option.divider && option.value === value) {
					selectedOption = option;
				}
			}

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)(className, 'react-phone-number-input__country--native') },
				selectedOption && _react2.default.createElement(selectedOption.icon, { value: value }),
				_react2.default.createElement(
					'select',
					{
						name: name,
						value: value || 'ZZ',
						onChange: this.onChange,
						disabled: disabled,
						tabIndex: tabIndex,
						className: 'react-phone-number-input__country-select' },
					options.map(function (_ref3) {
						var value = _ref3.value,
						    label = _ref3.label,
						    divider = _ref3.divider;
						return _react2.default.createElement(
							'option',
							{
								key: divider ? '|' : value || 'ZZ',
								value: divider ? '|' : value || 'ZZ',
								disabled: divider ? true : false,
								className: divider ? 'react-phone-number-input__country-select-divider' : undefined },
							label
						);
					})
				),
				_react2.default.createElement(SelectArrow, null)
			);
		}
	}]);

	return CountrySelectNative;
}(_react.Component), _class.propTypes = {
	selectArrowComponent: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
	selectArrowComponent: function selectArrowComponent() {
		return _react2.default.createElement('div', { className: 'react-phone-number-input__country-select-arrow' });
	}
}, _temp2);
exports.default = CountrySelectNative;
//# sourceMappingURL=CountrySelectNative.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/commonjs/CountrySelectNative.js
// module id = 1687
// module chunks = 0